$(document).ready(function(){
  $("button.readmore-btnn").on("click", function(){
    $(".read-less-area").hide();
    $(".read-more-area").show();
  })

  $("button.readless-btnn").on("click", function(){
    $(".read-less-area").show();
    $(".read-more-area").hide();
  })
    $("li.disclosure__itemm").on("click", function (e){
     e.preventDefault();
    // e.stopPropagation();

    var href = $(this).find("a").attr("href")
     var cleanHref = href.split('?')[0];
    console.log('$(this).find("a").attr("href")',$(this).find("a").attr("href"),cleanHref)
    window.location.href = cleanHref;
  })

   $(".disclosure__item_el").on("click", function (e){
     e.preventDefault();
    // e.stopPropagation();

    var href = $(this).attr("href")
     var cleanHref = href.split('?')[0];
    console.log('$(this).find("a").attr("href")',$(this).attr("href"),cleanHref)
    window.location.href = cleanHref;
  })

  
  
  // $("product-swatch").each(function(){
  //   var getOption = $(this).attr("option-to-select");
  //   if ( getOption != "" )
  //   {
  //     $(this).find("input").prop("checked", false);
  //   }
    
  // })
  
  var tabHeading = $(".tab-heading-active").attr("related-tab");
  $(".tab-content[for='"+tabHeading+"']").show();
  var getSelected = $("product-swatch.swatch[data-option-index='1']").find("input:checked").val();
  $(".option-swatch-group label.swatch-label").find("input").val(getSelected).prop('checked', true);
  $(".bundle-items-n[target='"+getSelected+"']").show();
  $(".bundle-items-n[target='"+getSelected+"']").prevAll(".bundle-items-n").hide();
  $(".bundle-items-n[target='"+getSelected+"']").nextAll(".bundle-items-n").hide();
  
  var getcompare = $(".option-swatch-group label.swatch-label").find("input:checked").attr("val-in");
  $(".custm-bundle-pr-items li[rel-"+getcompare+"='"+getcompare+"']").addClass("active-bundle-products");
   $(".custm-bundle-pr-items li").not("[rel-"+getcompare+"='"+getcompare+"']").addClass("disabled-bundle-products");
  
   $("button.readmore-btn").on("click", function(){
     $(this).hide();
     $("button.readless-btn").show();
     //$(".product-description.product-form-block.custom-description-tab").removeClass("readmore-andless-desc");
     $(".truncated-description").hide();
     $(".full-description").show();
   })
   $("button.readless-btn").on("click", function(){
     $(this).hide();
     $("button.readmore-btn").show();
     //$(".product-description.product-form-block.custom-description-tab").addClass("readmore-andless-desc");
     $(".truncated-description").show();
     $(".full-description").hide();
   })
  $("button.swiper-button-next").on("click", function(){
    $(".swiper-pagination .swiper-pagination-bullet-active").next("span.swiper-pagination-bullet").trigger("click");
  })
  $("button.swiper-button-prev").on("click", function(){
    $(".swiper-pagination .swiper-pagination-bullet-active").prev("span.swiper-pagination-bullet").trigger("click");
  })
  var arrayID = [];
  $("product-swatch.swatch").each(function(){
      
      var opt = $(this).find("input:checked").val();
      arrayID.push(opt);
      var finalVal = arrayID.join("-");
      $(".heading-specs-main").text(finalVal);
      $(".relative-content-on[selected='"+finalVal+"']").addClass("active-tab");
      $(".relative-content-on[selected='"+finalVal+"']").nextAll(".relative-content-on").removeClass("active-tab");
      $(".relative-content-on[selected='"+finalVal+"']").prevAll(".relative-content-on").removeClass("active-tab");
      $(".tech-details-tab-c[slected-option='"+finalVal+"']").show();
      $(".tech-details-tab-c[slected-option='"+finalVal+"']").nextAll(".tech-details-tab-c").hide();
      $(".tech-details-tab-c[slected-option='"+finalVal+"']").prevAll(".tech-details-tab-c").hide();
      
    })
  
  $(document).on('change', 'product-swatch[data-option-index="1"] input', function(){
    $("button.btn.product--add-to-cart-button").removeClass("disabled--button");
    // $(this).addAttribute("checked");
    // $(this).parents(".swatch-element").prevAll(".swatch-element").find("inout").removeAttribute("checked");
    // $(this).parents(".swatch-element").nextAll(".swatch-element").find("inout").removeAttribute("checked");
  })
 // $("button.btn.product--add-to-cart-button").addClass("disabled--button");
  //$("product-swatch[data-option-index='1']").find(".swatch-element input").removeAttr("checked");
  
  $(document).on('change','product-swatch input',function() {
    setTimeout(function(){
    arrayID = [];
   var getID = $(".product-variant-id").val();
    console.log(getID)

// $('.product-medias__main').css({"opacity":"0"});
    $(".swiper-slidee[variant-media-new='Yes']").attr("data-variant-value", getID) 
    $(".swiper-slide[data-varaiant-thumbnail-new='Yes']").attr("data-thumbnail-variant-value", getID)
    var getImageP = $("select.custom-option-selection option[value='"+getID+"']").val();
    console.log('getImageP',getImageP)
    console.log($('.swiper-wrapper .swiper-slidee').length)
    console.log($(".swiper-slidee[data-variant-value='"+getImageP+"']").length)
    
      $('.swiper-wrapperr').slick('slickUnfilter');
    if ( $(".swiper-slidee[data-variant-value='"+getImageP+"']").length > 0 )
    {
      $("input.media-switch").prop('checked', false)
      $("input.media-switch").removeAttr("disabled");
      $('.swiper-wrapperr').slick('slickFilter', $(".swiper-slidee[data-variant-value='"+getImageP+"']")).slick("refresh");
      setTimeout(function(){
      $(".swiper-wrapperr").slick('slickGoTo', 0);
        console.log("go to")



setTimeout(function(){



        var active_val = '';
       active_val = $('.swatch-option-2 input:checked').val();
       console.log('active_val',active_val)

       $('.swatch-option-2 .swatch-element').each(function(){
      var active_lab = '0';
      if(active_val == '' || active_val == 'undefined' || active_val == undefined){
        if(active_lab == '0'){
          console.log('2');
        $(this).find('label').trigger('click');
        active_lab = '1';
        }
      }
    })

    var variantUrl = '/variants/' + getImageP + '.json';
      console.log('variantUrl',variantUrl)

// $.getJSON(variantUrl, function(data) {
//     if (data && data.variant && data.variant.metafields) {
//       console.log('data',data)
//         var metafields = data.variant.metafields;
//         console.log('metafields',metafields)
        
//         // Find the image metafield
//         var imageMetafield = metafields.find(function(mf){
//             return mf.namespace === 'custom' && mf.key === 'variant_media_';
//         });
        
//         if(imageMetafield) {
//             var imageUrl = imageMetafield.value;
//             $('.product-medias__main .slick-current img').attr('src',imageUrl);
//       $('.thumbnail-media .slick-current img').attr('src',imageUrl);
//       $('.thumbnail-media .slick-current img').attr('srcset',imageUrl);
//       console.log('imageUrl',imageUrl)
//         } else {
//             console.log('No image metafield found for this variant.');
//         }
//     }
// });

if(active_val == '' || active_val == 'undefined' || active_val == undefined){
}else{
setTimeout(function(){
$('.swatch-element').each(function(){
  var data_img = $(this).attr('data-selected-swatch-variant-img');
  console.log('data_img',data_img)
  if (data_img && data_img.includes(".gif")) {
  }else{
  $('.product-medias__main .slick-current img').attr('src',data_img);
      $('.thumbnail-media .slick-current img').attr('src',data_img);
      $('.thumbnail-media .slick-current img').attr('srcset',data_img);
  }
})
}, 500)
}

// setTimeout(function(){
//   $('.product-medias__main').css({"opacity":"1"});
//   }, 900)

  }, 600)





        }, 300);
        
    }
    else
    {
      $("input.media-switch").attr("disabled","disabled");
    }
    $('.swiper-wrapperrr').slick('slickUnfilter');
    if ( $(".swiper-slide[data-thumbnail-variant-value='"+getImageP+"']").length > 0 )
    {  
      $('.swiper-wrapperrr').slick('slickFilter', $(".swiper-slide[data-thumbnail-variant-value='"+getImageP+"']")).slick("refresh");
     // $('.swiper-wrapperrr').slick('slickGoTo', 0);
      //setTimeout(function(){
      // $('.swiper-wrapperrr .swiper-slide[data-varaiant-thumbnail="Yes"]').trigger("click");
      //   console.log("go to cliekc")
      //   }, 500);
    }
    else
    {
      $("input.media-switch").attr("disabled","disabled");
    }
    $('.shopify-payment-button__more-options').text("Buy Now")
    $("product-swatch.swatch").each(function(){
      var opt = $(this).find("input:checked").val();
      arrayID.push(opt);
      var finalVal = arrayID.join("-");
       $(".heading-specs-main").text(finalVal);
      $(".relative-content-on[selected='"+finalVal+"']").addClass("active-tab");
      $(".relative-content-on[selected='"+finalVal+"']").nextAll(".relative-content-on").removeClass("active-tab");
      $(".relative-content-on[selected='"+finalVal+"']").prevAll(".relative-content-on").removeClass("active-tab");
      $(".tech-details-tab-c[slected-option='"+finalVal+"']").show();
      $(".tech-details-tab-c[slected-option='"+finalVal+"']").nextAll(".tech-details-tab-c").hide();
      $(".tech-details-tab-c[slected-option='"+finalVal+"']").prevAll(".tech-details-tab-c").hide();
      
    })
     }, 700);
  })
  //product custom slider
  $('.swiper-wrapperr').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    fade: false,
    dots: true,
    asNavFor: '.swiper-wrapperrr'
  });
  $('.swiper-wrapperrr').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.swiper-wrapperr',
    dots: false,
    infinite: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true
  });
  
  //logo slider 
  $(function() {
    var $slider = $('.homepage-section--logo-bar-wrapper .logo-bar');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
    $('.homepage-section--logo-bar-wrapper .logo-bar').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        autoplay:true,
        speed: 1000,
        dots: true,
        responsive: [
            {
                breakpoint: 769,
                settings: 'unslick'
            }
        ]
    });

    $(window).on('resize', function() {
        $('.homepage-section--logo-bar-wrapper .logo-bar').slick('resize');
    });
});
  
  $('.swiper-wrapperr').slick('slickUnfilter');
  $('.swiper-wrapperr').slick('slickFilter', $(".swiper-slidee[variant-media='No']")).slick('refresh');
  $('.swiper-wrapperrr').slick('slickUnfilter');
  $('.swiper-wrapperrr').slick('slickFilter', $(".swiper-slide[data-varaiant-thumbnail='No']")).slick('refresh');

  $("input.media-switch").on("change", function(){
    if($(this).is(':checked'))
    {
      $('.swiper-wrapperr').slick('slickUnfilter');
      $('.swiper-wrapperr').slick('slickFilter', $(".swiper-slidee[variant-media='No']")).slick('refresh');
      $('.swiper-wrapperrr').slick('slickUnfilter');
      $('.swiper-wrapperrr').slick('slickFilter', $(".swiper-slide[data-varaiant-thumbnail='No']")).slick('refresh');
    } 
    else
    {
      var getID = $(".product-variant-id").val();
    $("input.media-switch").prop('checked', false)
    var getImageP = $("select.custom-option-selection option[value='"+getID+"']").val();
      $('.swiper-wrapperr').slick('slickUnfilter');
    if ( $(".swiper-slidee[data-variant-value='"+getImageP+"']").length > 0 )
    {
      $('.swiper-wrapperr').slick('slickFilter', $(".swiper-slidee[data-variant-value='"+getImageP+"']")).slick('refresh');
      
    }
    $('.swiper-wrapperrr').slick('slickUnfilter');
    if ( $(".swiper-slide[data-thumbnail-variant-value='"+getImageP+"']").length > 0 )
    {  
      $('.swiper-wrapperrr').slick('slickFilter', $(".swiper-slide[data-thumbnail-variant-value='"+getImageP+"']")).slick('refresh');
    }      
    }
  })
  //product features slider
  
  $('ul.product-features-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 48 48" class="w-10 h-10 md:w-12 md:h-12 text-neutral-50" aria-hidden="true"><path fill="currentColor" d="M28.154 32.573v4.89L9.488 28.13v-4.89z"></path><path fill="currentColor" d="M40.783 21.482v4.426l-31.11-.02v-4.425l31.11.02Z"></path><path fill="currentColor" d="m28.152 14.669.002-4.892-18.669 9.335V24l18.667-9.332Z"></path></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 48 48" class="w-10 h-10 md:w-12 md:h-12" aria-hidden="true"><path fill="currentColor" d="M20.152 14.668v-4.89L38.82 19.11V24z"></path><path fill="currentColor" d="M7.523 25.758v-4.425l31.112.02v4.425z"></path><path fill="currentColor" d="m20.154 32.572-.002 4.891 18.67-9.334v-4.89z"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  $("button.cstm-spec-btn-t").on("click", function(){
    var tabHeading = $(this).attr("related-tab");
    $(this).addClass("tab-heading-active");
    $(this).parents(".cstm-spec-btn-item").prevAll(".cstm-spec-btn-item").find("button").removeClass("tab-heading-active");
    $(this).parents(".cstm-spec-btn-item").nextAll(".cstm-spec-btn-item").find("button").removeClass("tab-heading-active");
    $(".tab-content[for='"+tabHeading+"']").show();
    $(".tab-content[for='"+tabHeading+"']").parents(".tab-content-main").show();
    $(".tab-content[for='"+tabHeading+"']").parents(".tab-content-main").prevAll(".tab-content-main").hide();
    $(".tab-content[for='"+tabHeading+"']").parents(".tab-content-main").nextAll(".tab-content-main").hide();
  })
  $("button.feature-slide-button").on("click", function(){
    $(this).toggleClass("active-button-content");
  })

  $(".option-swatch-group label.swatch-label").find("input").on("change", function(){
    var getVal = $(this).attr("val-in");
    $(".custm-bundle-pr-items li[rel-"+getVal+"='"+getVal+"']").addClass("active-bundle-products");
    $(".custm-bundle-pr-items li[rel-"+getVal+"='"+getVal+"']").removeClass("disabled-bundle-products");
    $(".custm-bundle-pr-items li").not("[rel-"+getVal+"='"+getVal+"']").addClass("disabled-bundle-products");
    $(".custm-bundle-pr-items li").not("[rel-"+getVal+"='"+getVal+"']").removeClass("active-bundle-products");
    
  })

  $("button.product-list-item").on("click", function(){
    var image = $(this).find(".absolute.inset-0 img").attr("src");
    var url = $(this).attr("p-url");
    var pTitle = $(this).attr("title");
    $("h2.top-modal-heading").text(pTitle);
    $("a.top-modal-button").attr("href", url);
    $(".modal-product-image .modal-src").attr("src",image);
    $(".modal-quick-view").show();
  })
  
  $(".modal-quick-view span.close").on("click", function(){
    $(".modal-quick-view").hide();
  })

  $("product-swatch.swatch[data-option-index='1']").find("input").on("change", function(){
    $(".bundle-items-n[target='"+$(this).val()+"']").show();
    $(".bundle-items-n[target='"+$(this).val()+"']").prevAll(".bundle-items-n").hide();
    $(".bundle-items-n[target='"+$(this).val()+"']").nextAll(".bundle-items-n").hide();
  })
  var width = $(window).width();
  if ( width < 1024 )
  {
    $(".tab-content").hide();
    $(".tab-mobile-heading").on("click", function(){
      $(this).toggleClass("active-mobile-heading");
      $(this).parents(".tab-content-main").nextAll(".tab-content-main").find(".tab-mobile-heading").removeClass("active-mobile-heading");
      $(this).parents(".tab-content-main").prevAll(".tab-content-main").find(".tab-mobile-heading").removeClass("active-mobile-heading");
      $(this).parents(".tab-content-main").find(".tab-content").slideToggle();
      $(this).parents(".tab-content-main").nextAll(".tab-content-main").find(".tab-content").slideUp();
      $(this).parents(".tab-content-main").prevAll(".tab-content-main").find(".tab-content").slideUp();
    })
  }
  else
  {
    //$(".tab-heading-active").trigger("click");
    $(".tab-content-main:first-child").nextAll(".tab-content-main").hide();
  }
  $(window).resize(function(){
   var width = $(window).width();
  if ( width < 1024 )
  {
    $(".tab-content-main").show();
    $(".tab-content").hide();
    $(".tab-mobile-heading").on("click", function(){
      $(this).addClass("active-mobile-heading");
      $(this).parents(".tab-content-main").nextAll(".tab-content-main").find(".tab-mobile-heading").removeClass("active-mobile-heading");
      $(this).parents(".tab-content-main").prevAll(".tab-content-main").find(".tab-mobile-heading").removeClass("active-mobile-heading");
      $(this).parents(".tab-content-main").find(".tab-content").slideToggle();
      $(this).parents(".tab-content-main").nextAll(".tab-content-main").find(".tab-content").slideUp();
      $(this).parents(".tab-content-main").prevAll(".tab-content-main").find(".tab-content").slideUp();
    })
  }
  else
  {
    $(".tab-heading-active").trigger("click");
  } 
  })

  $("button.desktop-drop-navigation").on("click", function(){
    $(this).toggleClass("active-menu-btn");
    $(".custom-desktop-dropdown-menu").toggleClass("open-desk-menu-top-drop")
    $(".custom-desktop-dropdown-menu").slideToggle();
  })

  //spare parts page
  var urlValues = [];
  $("button.type-item").on("click", function(){
    urlValues = [];
    var target = $(this).attr("target");
    $("#"+target).show();
    $('html, body').animate({
      scrollTop: $('#'+target).offset().top
    }, 500); 
    $(this).addClass("active-button-item");
    $(this).parents(".page-bl-list-item").prevAll(".page-bl-list-item").find("button").removeClass("active-button-item");
    $(this).parents(".page-bl-list-item").nextAll(".page-bl-list-item").find("button").removeClass("active-button-item");
    $(".block-val-need").each(function(){
      var urlInput = $(this).find("button.active-button-item").attr("option-title");
      urlValues.push(urlInput);
    })
    var url = urlValues.join("-")
    var motors = $(this).attr("motors");
    var motor = motors.split(",");
    $(".page-bl-list-item.motors-item").removeClass("show-motors");
    $.each(motor, function(index, value) {
       $(".page-bl-list-item.motors-item[available-motor='"+value+"']").addClass("show-motors");
      
    });

    // $("div#page-blok-3rd .page-bl-list-item.motors-item").each(function(){
    //   var getval = $(this).find("button.type-item").attr("option-title");
    //   var finalUrl = url +"-"+ getval;
    //   console.log(finalUrl)
    //   //$(this).find("a.type-item").attr("href", finalUrl)
    // })

    
   //setfinal url in localstorage
  $("a.type-item").on("click", function(){
    var finalurl = url +"-"+ $(this).parents(".page-bl-list-item.motors-item").find("button").attr("option-title");
    localStorage.setItem("finalUrl", finalurl);
  }) 
  })
  
  var getUrl = localStorage.getItem("finalUrl");
  if ( getUrl != "" )
  {
    $(".list-combination[show-combination='"+getUrl+"']").show();
  }


  $(".scroll-down-btn").on("click", function(){
    var target = $(this).attr("scroll-down");
    $('html, body').animate({
      scrollTop: $('#'+target).offset().top
    }, 500); 
  })

  $('button.convert-btn-pdf').click(function () {
      var id = $(this).parents(".feature-tool-image").find("img").attr("id");
    var img = document.getElementById(id);
    console.log(img)
      var title = $(".list-combination h2.page-title").text();
      // Use html2canvas to capture the image
      html2canvas(img).then(function (canvas) {
        var imgData = canvas.toDataURL('image/png');
        
        // Use jsPDF to create a PDF
        const { jsPDF } = window.jspdf;
        var pdf = new jsPDF();
        
        // Add the image to the PDF (position: x=10, y=10, width, height)
        pdf.addImage(imgData, 'JPEG', 10, 10, 180, 160);
        
        // Download the PDF
        pdf.save(title+'.pdf');
      });
    });

   $("input.search-spare-parts").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(this).parents(".section-all-spare-parts").find(".grid__item.medium--one-third").filter(function() {
      $(this).toggle($(this).find("h4.h4").text().toLowerCase().indexOf(value) > -1)
    });
  });

  $(".faq-heading").on("click", function(){
    $(this).toggleClass("active-faq");
    $(this).parents(".faq-item").prevAll(".faq-item").find(".faq-heading").removeClass("active-faq");
    $(this).parents(".faq-item").nextAll(".faq-item").find(".faq-heading").removeClass("active-faq");
    $(this).parents(".faq-item").find(".faq-content").slideToggle();
    $(this).parents(".faq-item").prevAll(".faq-item").find(".faq-content").slideUp();
    $(this).parents(".faq-item").nextAll(".faq-item").find(".faq-content").slideUp();
  })
  $("document").on("click", ".swiper-wrapperrr .swiper-slide .product-medias__thumbnail", function(){
    console.log("thunbnail clicked");
  })

//inner spare parts page popup
  // $("a.request-to-buy").on("click", function(){
  //   var getPtitle = $(this).siblings("span.product-to-buy").text();
  //   $(".request-to-buy-popup").show();
  //   $(".product-title").val(getPtitle)
  // })
  // $(".close-req").on("click", function(){
  //   $(".request-to-buy-popup").hide();
  // })
  $("form.localization-form button.disclosure__button").on("click", function(){
    $(this).parents(".disclosure").find("ul.disclosure__list").removeAttr("hidden");
  })
  // $("li.disclosure__itemm").on("click", function(){
  //   $(this).parents("ul.disclosure__list").attr("hidden", "true");
  // })
})
$(window).on("load", function(){
  $(".product--add-to-cart-button").removeClass("disabled--button");
  $("product-swatch").each(function(){
    var thiss = $(this);
    var getOption = $(this).attr("option-to-select");
    if ( getOption != ""  )
    {
      let checkInterval = setInterval(function() {
        if ($('input[value="'+getOption+'"]').is(':checked')) {
            console.log('Checkbox is checked!');
            $("button.btn.product--add-to-cart-button").removeClass("disabled--button");
            clearInterval(checkInterval); // Stop checking once it is checked
        } else {
            thiss.find("label[select-label='"+getOption+"']").trigger("click");        
            $("button.btn.product--add-to-cart-button").removeClass("disabled--button");
            console.log('Checkbox is not checked, checking again...');
        }
    }, 500);
    } 
    
    
  })
})
$(document).ready(checkContainerr);

function checkContainerr() {
  if($('.shopify-payment-button__more-options').is(':visible')){ //if the container is visible on the page
   $('.shopify-payment-button__more-options').text("Buy Now")
    setTimeout(function(){ $('.shopify-payment-button__more-options').text("Buy Now") }, 2000);
  } else {
    //console.log("not found");
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
    
  }
}

$(document).ready(function () {
        var get = $("header.site-header.wrapper-spacing--h form#FooterCountryForm button.disclosure__button.alt-focus").html();
        $(".custom-footer-store-link button.disclosure__buttonn").html(get);
        // Toggle the ul visibility when the button is clicked
        $(".disclosure__buttonn").on("click", function (e) {
            e.stopPropagation(); // Prevent the click event from bubbling up
            $(".custom-ul-li").toggle(); // Toggle the hidden attribute           
        });

        // Hide the ul when clicking outside the button or the ul
        $(document).on("click", function (e) {
            if (!$(e.target).closest(".disclosure__buttonn, .custom-ul-li").length) {
                $(".custom-ul-li").hide(); // Hide the ul
                $(".disclosure__buttonn").attr("aria-expanded", "false"); // Update aria-expanded
            }
        });

        // Prevent the ul from closing when clicking inside it
        $(".custom-ul-li").on("click", function (e) {
            e.stopPropagation(); // Prevent the click event from bubbling up
        });
        // $(".list-item a.disclosure__item_el").on("click", function(){
        //   $(this).parents("ul").hide();
        // })
  $(".js-drawer-open-right-link").on("click", function(){
    //setTimeout(function(){
    fetchCartAndUpdateBar();
      //}, 2000);
  })
  $(document).on("click", "button.ajaxcart__qty-adjust", function(){
   setTimeout(function(){
    fetchCartAndUpdateBar();
      }, 2000);
  })
  $(document).on("change", ".ajaxcart__qty input.ajaxcart__qty-num", function(){
     setTimeout(function(){
    fetchCartAndUpdateBar();
      }, 2000);
  })
    });

    // Helper function to toggle the hidden attribute
    $.fn.toggleAttr = function (attr) {
        return this.each(function () {
            var $this = $(this);
            if ($this.attr(attr) === "true") {
                $this.removeAttr(attr);
            } else {
                $this.attr(attr, "true");
            }
        });
    };

  const freeShippingThreshold = 50.00; // £50

  function updateFreeShippingBar(cart) {
    const cartTotal = cart.total_price / 100; // Shopify returns in pence
    const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
    console.log(cartTotal)
    console.log(progress)
    
    if (cartTotal < freeShippingThreshold) {
      const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
      $('.free-shipping-bar .shipping-message').html(`Spend £${remaining} more for <b>FREE delivery</b>!`);
    } else {
      $('.free-shipping-bar .shipping-message').html("🎉 Congrats! You've unlocked <b> FREE SHIPPING! </b>");
    }
    if ( cartTotal < 1 )
    {
      $(".free-shipping-bar").hide();
    }

    $('.shipping-progress').css('width', `${progress}%`);
  }

  // Call this function after cart is updated/shown
  function fetchCartAndUpdateBar() {
    $.getJSON('/cart.js', function(cart) {
      updateFreeShippingBar(cart);
      console.log('mainn')
    });
  }

  // Run on page load (optional if drawer is loaded via AJAX later)
  $(document).ready(function () {
    fetchCartAndUpdateBar();
  });

  // Optional: also re-run when items are added or removed
  $(document).on('cart:updated', function () {
    fetchCartAndUpdateBar();
    setTimeout(function(){
      fetchCartAndUpdateBar();
      console.log('update cart')
    }, 1000)
  });

//# sourceMappingURL=theme.js.map

document.addEventListener("DOMContentLoaded", () => {
  // document.querySelectorAll("#CountryList a.disclosure__item_el").forEach(link => {
  //   link.addEventListener("touchend", function(e) {
  //     const url = this.getAttribute("href");
  //     if (url && url !== "#") {
  //       window.location.href = url;   // forces redirect on iOS
  //     }
  //   });

  //   link.addEventListener("click", function(e) {
  //     const url = this.getAttribute("href");
  //     if (url && url !== "#") {
  //       window.location.href = url;   // fallback for desktop
  //     }
  //   });
  // });


        $('.swiper-wrapperr').on('afterChange', function(event, slick, currentSlide){
    
          document.querySelectorAll('.wc-pdp-video video').forEach(video => {
        video.pause();
        video.currentTime = 0;
      });

      document.querySelectorAll('.wc-pdp-video button').forEach(button => {
  button.style.display = 'none';
});


      const activeVideo = document.querySelector(
        '.slick-current .wc-pdp-video video'
      );

      if (activeVideo) {
        activeVideo.muted = true;
        activeVideo.playsInline = true;
        activeVideo.play().catch(() => {});
      }
          

});

document.querySelectorAll('.disclosure__item_el').forEach(function(el) {
  var href = el.getAttribute('href');

  if (href && href.includes('?')) {
    var cleanHref = href.split('?')[0];
    el.setAttribute('href', cleanHref);
  }
});


setTimeout(function(){
  document.querySelectorAll('.disclosure__item_el').forEach(function(el) {
  var href = el.getAttribute('href');

  if (href && href.includes('?')) {
    var cleanHref = href.split('?')[0];
    el.setAttribute('href', cleanHref);
  }
});

}, 1500)

setTimeout(function(){
  document.querySelectorAll('.disclosure__item_el').forEach(function(el) {
  var href = el.getAttribute('href');

  if (href && href.includes('?')) {
    var cleanHref = href.split('?')[0];
    el.setAttribute('href', cleanHref);
  }
});

}, 3000)

setTimeout(function(){
  document.querySelectorAll('.disclosure__item_el').forEach(function(el) {
  var href = el.getAttribute('href');

  if (href && href.includes('?')) {
    var cleanHref = href.split('?')[0];
    el.setAttribute('href', cleanHref);
  }
});

}, 5000)


});



// document.querySelectorAll('.disclosure__item_el').forEach(function(el) {
//   var href = el.getAttribute('href');

//   if (href && href.includes('?')) {
//     var cleanHref = href.split('?')[0];
//     el.setAttribute('href', cleanHref);
//   }
// });
